import React, { createContext, useContext, useState } from 'react';

import type { SharingModalProps } from 'src/app/pages/starterDashboardV2/shared/components';
import { SharingModal } from 'src/app/pages/starterDashboardV2/shared/components';

type SharingModalPropsInternal = Omit<SharingModalProps, 'isOpen'>;

type SharingModalContextType = {
	startSharingFlow: (props: SharingModalPropsInternal) => void;
	stopSharingFlow: () => void;
};

const SharingModalContext = createContext<SharingModalContextType>({
	startSharingFlow: (_props: SharingModalPropsInternal) => {},
	stopSharingFlow: () => {},
});

export const useSharingModal = () => useContext(SharingModalContext);

export const SharingModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [sharingModalProps, setSharingModalProps] = useState<SharingModalProps | null>(null);

	const startSharingFlow = (props: SharingModalPropsInternal) => {
		setSharingModalProps({ ...(props as SharingModalProps), defaultOpen: true });
	};

	const stopSharingFlow = () => {
		setSharingModalProps(null);
	};

	return (
		<SharingModalContext.Provider value={{ startSharingFlow, stopSharingFlow }} data-testid="sharing-modal-context">
			{children}
			{sharingModalProps && <SharingModal {...sharingModalProps} />}
		</SharingModalContext.Provider>
	);
};
